import React from 'react';
import { Check } from 'lucide-react';
import type { LicensingOption } from '../flow';

/**
 * .pen "stage cards": the active question's answers as full-width surface cards
 * with a radio on the right. One tap answers and advances the step, so there is
 * no per-question Continue.
 */
export interface ChoiceCardsProps {
  name: string;
  options: LicensingOption[];
  value?: string;
  onChange: (value: string) => void;
  testIdPrefix: string;
}

export const ChoiceCards: React.FC<ChoiceCardsProps> = ({
  name,
  options,
  value,
  onChange,
  testIdPrefix,
}) => (
  <div className="space-y-2" role="radiogroup" aria-label={name}>
    {options.map((option) => {
      const selected = option.value === value;
      return (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={selected}
          data-testid={`${testIdPrefix}-${option.value}`}
          onClick={() => onChange(option.value)}
          className={`w-full flex items-center justify-between gap-3 px-4 py-3.5 rounded-xl border-2 text-left transition-colors ${
            selected
              ? 'border-primary-500 bg-primary-50'
              : 'border-neutral-200 bg-white hover:border-primary-300'
          }`}
        >
          <span
            className={`text-base font-semibold ${selected ? 'text-primary-700' : 'text-neutral-900'}`}
          >
            {option.label}
          </span>
          <span
            className={`w-5 h-5 shrink-0 rounded-full border-2 flex items-center justify-center ${
              selected ? 'border-primary-500 bg-primary-500' : 'border-neutral-300'
            }`}
            aria-hidden="true"
          >
            {selected && <Check className="w-3 h-3 text-white" />}
          </span>
        </button>
      );
    })}
  </div>
);

export default ChoiceCards;
